import script from "./IndexTour.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndexTour.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__